import {combineReducers} from 'redux';

import base from './reducer';
import fees from './fees/reducer';
import accounts from './accounts/reducer';

const reducer = combineReducers({
  base,
  fees,
  accounts
});

export default reducer;



// WEBPACK FOOTER //
// ./src/features/finance/rootReducer.js